import ReactLoadingSkeleton from 'react-loading-skeleton';

import type { SkeletonProps } from '../Skeleton.types';

export const MatchingResolutionButtonsSkeleton = ({ ...props }: SkeletonProps) => {
  return (
    <div
      className="flex flex-row [&_.react-loading-skeleton]:border [&_.react-loading-skeleton]:border-neutral-300"
      data-testid="skeleton-matching-resolution-buttons"
      {...props}
    >
      <ReactLoadingSkeleton height={40} style={{ borderBottomRightRadius: 0, borderTopRightRadius: 0 }} width={112} />
      <ReactLoadingSkeleton borderRadius={0} height={40} width={112} />
      <ReactLoadingSkeleton borderRadius={0} height={40} width={112} />
      <ReactLoadingSkeleton borderRadius={0} height={40} width={112} />
      <ReactLoadingSkeleton height={40} style={{ borderBottomLeftRadius: 0, borderTopLeftRadius: 0 }} width={112} />
    </div>
  );
};
